<script>
import { mapState } from 'vuex';
import VsButton from 'viralstyle-ui/src/VsButton';

import clientMixins from 'utils/client-mixins';

export default {
  components: {
    VsButton,
  },
  mixins: [clientMixins],
  props: {
    referral: [String, Boolean],
  },
  computed: {
    ...mapState({
      processing: state => state.processing,
      currentUser: state => state.currentUser,
      emailVerificationRequested: state => state.emailVerificationRequested,
    }),
    payoutText() {
      return this.referral ? 'referral payouts' : 'payouts';
    },
  },
  methods: {
    async handleResendVerificationEmailClick() {
      await this.$store.dispatch('post', { apiUrl: this.currentUser._links.send_email_verification.href });

      this.$store.commit('updateState', { object: this.$store.state, property: 'emailVerificationRequested', value: true });
    },
  },
};
</script>

<template lang='pug'>
.vs-container
  .payouts__form-required

    template(v-if='!currentUser.valid_w9')
      h1 W-9 or W-8 required before {{payoutText}} are available.
      h2
        a.vs-link(href='https://app.hellosign.com/s/d6cee5c2', target='_blank') Click here&nbsp;
        | to submit W-9 form.
      br
      h3 Outside of the US?&nbsp;
        a.vs-link(href='https://app.hellosign.com/s/4efd5b27', target='_blank') Click here&nbsp;
        | to submit W-8 form.
      h5 Once the W-9 or W-8 is received and verified, return to this screen to process {{payoutText}}.

    template(v-else-if='currentUser._links.send_email_verification.href')
      h1 Email must be verified before {{payoutText}} are available.
      vs-button(
        v-if='!emailVerificationRequested',
        large,
        text='Resend Verification Email',
        :processing='processing',
        :disabled='processing',
        @click='handleResendVerificationEmailClick',
      )
      template(v-else)
        h3 Verification Email Sent!
        h5 Once your email is verified, return to this screen or refresh the page if you have not left.
</template>

<style>
@import '~import/index';
</style>